const UtmGuids = {
  siaExperianReferral: 'siaExperianReferral',
};

export default UtmGuids;
